class MagazinList extends HTMLElement {
  constructor() {
    super();
    this.onClick = this.handleClick.bind(this);
    this.isLoading = false;
  }

  connectedCallback() {
    this.addEventListener('click', this.onClick);
  }

  disconnectedCallback() {
    this.removeEventListener('click', this.onClick);
  }

  getLoadingLabel() {
    return this.getAttribute('data-loading-label') || 'Lädt…';
  }

  getItemsContainer() {
    return this.querySelector('[data-magazin-items]');
  }

  getNavContainer() {
    return this.querySelector('[data-magazin-nav]');
  }

  getControlContainer() {
    return this.querySelector('[data-magazin-control]');
  }

  getLoadLink() {
    return this.querySelector('[data-magazin-load]');
  }

  setLoadingState(isLoading) {
    const control = this.getControlContainer();
    if (control) {
      if (isLoading) control.setAttribute('data-loading', '');
      else control.removeAttribute('data-loading');
      control.setAttribute('aria-busy', isLoading ? 'true' : 'false');
    }
  }

  async fetchDocument(url) {
    const response = await fetch(url, { method: 'GET', credentials: 'same-origin' });
    if (!response.ok) throw new Error(`Request failed: ${response.status}`);
    const html = await response.text();
    return new DOMParser().parseFromString(html, 'text/html');
  }

  updateActiveFilter(clickedLink) {
    const nav = this.getNavContainer();
    if (!nav) return;

    const links = nav.querySelectorAll('a[data-magazin-filter]');
    for (const a of links) a.removeAttribute('data-active');

    if (clickedLink) clickedLink.setAttribute('data-active', '');
  }

  async handleClick(event) {
    const target = event.target instanceof Element ? event.target : null;
    if (!target) return;

    const loadLink = target.closest('a[data-magazin-load]');
    const filterLink = target.closest('a[data-magazin-filter]');
    const link = loadLink || filterLink;
    if (!link) return;
    if (!this.contains(link)) return;

    const href = link.getAttribute('href') || '';
    if (!href) return;

    event.preventDefault();
    if (this.isLoading) return;

    const items = this.getItemsContainer();
    const control = this.getControlContainer();
    const nav = this.getNavContainer();
    if (!items) return;

    const originalLabel = link.textContent || '';
    if (loadLink) {
      link.textContent = this.getLoadingLabel();
    }

    this.isLoading = true;
    this.setLoadingState(true);

    try {
      const doc = await this.fetchDocument(href);

      const nextNav = doc.querySelector('[data-magazin-nav]');
      const nextItems = doc.querySelector('[data-magazin-items]');
      const nextControl = doc.querySelector('[data-magazin-control]');

      if (!nextItems) throw new Error('Missing next items container');

      if (filterLink) {
        items.replaceChildren(...Array.from(nextItems.children));
        if (nav && nextNav) nav.innerHTML = nextNav.innerHTML;
        if (control) {
          if (nextControl) control.innerHTML = nextControl.innerHTML;
          else control.innerHTML = '';
        }

        if (history && typeof history.pushState === 'function') {
          history.pushState(null, '', href);
        }

        const newActive = this.querySelector(`a[data-magazin-filter][href="${CSS.escape(href)}"]`);
        this.updateActiveFilter(newActive || null);
      } else if (loadLink) {
        if (!control) throw new Error('Missing control container');
        const children = Array.from(nextItems.children);
        for (const child of children) items.appendChild(child);

        const nextLink = doc.querySelector('a[data-magazin-load]');
        if (nextLink && nextLink.getAttribute('href')) {
          loadLink.setAttribute('href', nextLink.getAttribute('href'));
          loadLink.textContent = originalLabel;
        } else {
          control.innerHTML = '';
          control.setAttribute('data-finished', '');
        }
      }
    } catch (error) {
      if (loadLink) link.textContent = originalLabel;
    } finally {
      this.isLoading = false;
      this.setLoadingState(false);
    }
  }
}

if (!customElements.get('magazin-list')) {
  customElements.define('magazin-list', MagazinList);
}

